<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">
      <header>
        <h2>Login</h2>
      </header>

      <div class="contact-form-container">
        <form [formGroup]="loginForm" method="post">
          <div class="row gtr-uniform">

            <div class="col-12 email-input">
              <input type="email" class="form-control " formControlName="email" name="email" id="email" value=""
                placeholder="Email">
            </div>

            <div class="col-12 form-group password-input-container">

              <input [type]="passwordType()" class="form-control" formControlName="password" name="password" id="password"
                value="" placeholder="Password">

              <button type="button" class="show-pass" (click)="onShowHide()">
                @if (!show()) {
                <i class="fa fa-eye" aria-hidden="true"></i>
                }
                @if (show()) {
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                }
              </button>

            </div>

            <div class="col-12 ">
              <button class="login-btn" (click)="onSubmit()">{{loginMSG()}}
                @if (loading()) {
                <span class="button-spinner"></span>
                }
              </button>
            </div>

          </div>

          <div class="pass-err">
            @if (errorMessage()) {
            <div class="invalid-feedback d-block" data-testid="error-server" role="alert" aria-live="polite">
              <div>{{errorMessage()}}</div>
            </div>
            }
            @if ((submitted() || rf.email.dirty) && rf.email.errors) {
            <div class="invalid-feedback d-block" data-testid="error-email">
              @if (rf.email.errors['required']) {
              <div>Email is required.</div>
              }
            </div>
            }
            @if ((submitted() || rf.password.dirty) && rf.password.errors) {
            <div class="invalid-feedback d-block" data-testid="error-password">
              @if (rf.password.errors['required']) {
              <div>Password is required.</div>
              }
            </div>
            }
          </div>
        </form>

        <div class="col-12 link-container">
          <a routerLink="/request-reset" class="action-link">Reset Password</a>
        </div>
        <div class="col-12 link-container">
          <a routerLink="/register" class="action-link">Register</a>
        </div>
      </div>

    </div>
  </div>
</section>